<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />
            <td class="w0 nowrap">
              {{
                item.created_at
                  | moment(
                    'timezone',
                    currentUser.active_project.timezone,
                    'MM/DD/YY h:mm A'
                  )
              }}
            </td>
            <td class="w0 nowrap">
              {{
                item.updated_at
                  | moment(
                    'timezone',
                    currentUser.active_project.timezone,
                    'MM/DD/YY h:mm A'
                  )
              }}
            </td>
            <td>
              <router-link :to="`/dev-tools/custom-components/${item.id}/edit`">
                {{ item.title }}
              </router-link>
            </td>
            <td>
              <span v-for="page in item.pages" :key="page.id" class="mr-3">
                <router-link class="nowrap" :to="`/pages/${page.id}/edit`">{{
                  page.title
                }}</router-link>
              </span>
              <span v-if="item.place_in_layout && item.place_in_layout != 'none'" class="mr-3">
                <span class="nowrap" >{{
                  placesInLayout[item.place_in_layout]
                }}</span>
              </span>
            </td>
            <td class="text-center nowrap w0">
              <div class="custom-component-actions">
                <Actions
                  hide-duplicate
                  :path="`/dev-tools/custom-components/${item.id}`"
                  @destroy="$emit('destroy', item)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sentList: [],
      placesInLayout: {
        sidebar_top: "Sidebar, top",
        sidebar_bottom: "Sidebar, bottom",
        header_top: "Header, top",
        header_bottom: "Header, bottom",
      }
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'Created Date',
          align: 'start',
          value: 'created_at',
        },
        {
          text: 'Updated Date',
          align: 'start',
          value: 'updated_at',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        {
          text: 'Locations',
          align: 'start',
          value: 'pages',
        },
        {
          align: 'center',
          sortable: false,
        },
      ];
    },
  },
  methods: {
    async sendCustomComponent(custom_component) {
      await this.$api.CustomComponent.sendCustomComponent(custom_component);
      // this.sentList.push(custom_component.id);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-component-actions {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>
